import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { FACEBOOK_URL, INSTAGRAM_URL, YOUTUBE_URL } from '../utils/constants'
import './Layout.css'
import RequestFab from './RequestFab'
import FranchiseDetailsModal from './FranchiseDetailsModal'

const Layout = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [requestMenuOpen, setRequestMenuOpen] = useState(false)
  const [franchiseModalOpen, setFranchiseModalOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const { isAuthenticated, user, logout, isAdmin, isFranchise } = useAuth()

  const isActive = (path) => location.pathname === path

  const handleLogout = async () => {
    await logout()
    navigate('/')
    setMobileMenuOpen(false)
  }

  return (
    <div className="layout">
      <header className="header">
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo-link" onClick={() => setMobileMenuOpen(false)}>
              <div className="logo-text-v2">
                <span className="logo-part-nah">NAH</span>
                <span className="logo-part-44">44</span>
              </div>
            </Link>

            <button
              className={`mobile-menu-toggle ${mobileMenuOpen ? 'open' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
              {/* Primary Actions */}
              {/* <Link
                to="/scan"
                className={`nav-link ${isActive('/scan') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                📷 Scan QR
              </Link> */}


              {/* Individual Resource Links */}
              <Link 
                to="/" 
                className={`nav-link ${isActive('/') ? 'active' : ''}`} 
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className={`nav-link ${isActive('/about') ? 'active' : ''}`} 
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link 
                to="/franchise" 
                className={`nav-link ${isActive('/franchise') ? 'active' : ''}`} 
                onClick={() => setMobileMenuOpen(false)}
              >
                contact
              </Link>
              <Link 
                to="/updates" 
                className={`nav-link ${isActive('/updates') ? 'active' : ''}`} 
                onClick={() => setMobileMenuOpen(false)}
              >
                Updates
              </Link>
              <Link 
                to="/more" 
                className={`nav-link ${isActive('/more') ? 'active' : ''}`} 
                onClick={() => setMobileMenuOpen(false)}
              >
                More
              </Link>

              {/* User Section */}
              {isAuthenticated ? (
                <>
                  <Link to="/profile" className={`nav-link ${isActive('/profile') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
                    Profile
                  </Link>

                  {isAdmin() && (
                    <Link to="/admin" className={`nav-link ${isActive('/admin') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
                      Admin
                    </Link>
                  )}

                  {isFranchise() && !isAdmin() && (
                    <Link to="/franchise/dashboard" className={`nav-link ${isActive('/franchise/dashboard') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
                      Dashboard
                    </Link>
                  )}

                  {user?.role === 'franchise_tags' && !isAdmin() && (
                    <Link to="/franchise/tags-dashboard" className={`nav-link ${isActive('/franchise/tags-dashboard') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
                      Tags
                    </Link>
                  )}

                  {!isAdmin() && (
                    <Link to="/orders" className={`nav-link ${isActive('/orders') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
                      Orders
                    </Link>
                  )}

                  <button onClick={handleLogout} className="nav-link logout-action">
                    Logout
                  </button>
                </>
              ) : (
                <Link
                  to="/login"
                  className="btn-primary"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Login
                </Link>
              )}
            </nav>
          </div>
        </div>
      </header>

      <main className="main-content">
        {children}
      </main>

      {/* Footer - Only show on home page */}
      {location.pathname === '/' && (
        <footer className="footer">
          <div className="container">
            <div className="footer-content">
              <div className="footer-section">
                <h3>About NAH44</h3>
                <p>
                  Our aim is to make it easier for people to contact the owners or family members of wrongly parked
                  or accident-involved vehicles. This system enables users to connect using unique QR code tags
                  linked to the vehicle owner's details.
                </p>
                <p style={{ marginTop: '1rem', fontSize: '0.85rem' }}>
                  <strong>Email:</strong> support@nah44.com<br />
                  <strong>Phone:</strong> +91 78423 05029<br />
                  <strong>Address:</strong> Plot No. 68WP, Badangpet, Maruthi Nagar, Balapur, Hyderabad, Telangana - 500058
                </p>
                <div className="footer-social">
                  <span className="footer-social-label">Follow us</span>
                  <div className="footer-social-links">
                    <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="footer-social-link">
                      Facebook
                    </a>
                    <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="footer-social-link">
                      Instagram
                    </a>
                    <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className="footer-social-link">
                      YouTube
                    </a>
                  </div>
                </div>
              </div>

              <div className="footer-section">
                <h3>Support</h3>
                <ul className="footer-links">
                  <li><Link to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link></li>
                  <li><Link to="/terms" onClick={() => window.scrollTo(0, 0)}>Terms & Conditions</Link></li>
                  <li><Link to="/privacy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link></li>
                  <li><Link to="/refund" onClick={() => window.scrollTo(0, 0)}>Cancellation & Refund Policy</Link></li>
                </ul>
              </div>

              <div className="footer-section">
                <h3>Frequently Asked Questions</h3>
                <div className="faq-container">
                  <div className="faq-item">
                    <h4>How does NAH44 work?</h4>
                    <p>Scan the QR code on a vehicle to instantly contact the owner through our secure, privacy-protected system.</p>
                  </div>
                  <div className="faq-item">
                    <h4>Is my contact information private?</h4>
                    <p>Yes! Your phone number remains private. Communication happens through our secure platform.</p>
                  </div>
                  <div className="faq-item">
                    <h4>Can I use it for emergencies?</h4>
                    <p>Absolutely! You can set up emergency contacts that can be reached quickly in case of accidents or urgent situations.</p>
                  </div>
                  <div className="faq-item">
                    <h4>Does it work without internet?</h4>
                    <p>NFC-enabled tags work offline, allowing contact information access without internet connectivity.</p>
                  </div>
                  <div className="faq-item">
                    <h4>How do I get a NAH44 tag?</h4>
                    <p>Check out the products section on the home page to order QR tags for your vehicle. Easy setup and instant activation.</p>
                  </div>
                  <div className="faq-item">
                    <h4>Can I update my vehicle details?</h4>
                    <p>Yes! Login to your dashboard anytime to update vehicle information, contact numbers, or emergency contacts.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <p>&copy; 2025 NAH44. All rights reserved.</p>
            </div>
          </div>
        </footer>
      )}

      {/* XALL & WhatsApp FAB - Show for all non-admin users */}
      {!isAdmin() && (
        <>
          <RequestFab
            isOpen={requestMenuOpen}
            onClick={() => setRequestMenuOpen(!requestMenuOpen)}
          />

          <FranchiseDetailsModal
            isOpen={franchiseModalOpen}
            onClose={() => setFranchiseModalOpen(false)}
          />
        </>
      )}
    </div>
  )
}

export default Layout


